<app-card-content [border]="false" [headerColor]="true" icon="pi pi-briefcase" title="Funções" subtitle="Funções e mandatos do médico">
    <div class="flex flex-col gap-4">
        <app-card-content [headerColor]="false" icon="pi pi-building" title="Funções em Entidades" subtitle="Mandatos em organizações">
            <app-custom-table (sortData)="onSortComposicao($event)" [metadata]="funcoesTableMetadata" [data]="funcoesMandatos()" [loading]="isLoading()" [initialViewMode]="'table'" />
        </app-card-content>

        <app-card-content [headerColor]="false" icon="pi pi-list" title="Detalhamento das Funções" subtitle="Detalhamento por CRM">
            <app-custom-table (sortData)="onSort($event)" [metadata]="detalhesFuncoesTableMetadata" [data]="detalhesFuncoes()" [loading]="isLoading()" [initialViewMode]="'table'" />
        </app-card-content>
    </div>
</app-card-content>
